import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import indiaStates from '../../../../../../../assets/js/india.state.list.json';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { StorageService } from 'src/app/Services/storage.service';
import { ApiService } from 'src/app/Services/api.service';
import { Router } from '@angular/router';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { type } from 'os';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { CommonServices } from 'src/app/Services/common.service';

export interface User {
  name: string;
}
declare const Compressor;
@Component({
  selector: 'app-event-driver',
  templateUrl: './event-driver.component.html',
  styleUrls: ['./event-driver.component.css']
})
export class EventDriverComponent implements OnInit {

  public breadcrumbData = {
    "Information": "/organization/transport-manager/information",
    "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
  };
  
  matFormSize = '13px';

  public eventDriverForm: FormGroup;
  myControl = new FormControl();
  public stateSelect = indiaStates.IND;
  options: User[] = [];
  public stateData = [];
  filteredOptions: Observable<User[]>;
  public userType: string;
  public userData: any;
  public imageField;
  public licenceImage;
  public profileImage;
  public isBranchDisabled = true;

  public tempProfilePic: any;
  public tempLicencePic:any;

  routerLinks:any;
  public finalCheck:boolean=false;

  public branchInformation:any = [];
  public branchlists = [];
  public shiftInformation:any = [];
  public shiftlists = [];
  public addressProof;
  public policeCertficate;
  public resume;
  imageUrl: any;
  minDate: Date;
  
  constructor(
    public api: ApiService,
    public storage: StorageService,
    public router: Router,
    public swal: SweetAlert,
    private loader: LoaderService,
    public file: FileUploadService,
    public comService:CommonServices
    ) {
    this.userType = this.storage.get('userType');
    this.userData = this.storage.get('vendorID_orgID');
    let vendorName = this.userData['vendorName'];

    if(vendorName){
      vendorName = this.comService.strTruncate(vendorName,13);
      this.breadcrumbData[vendorName] =  "/organization/transport-manager/information/vendor/single-view-vendor/"+this.userData.vendorID;
    }else{
      this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/"+this.userData.vendorID;
    }
    this.routerLinks = "/organization/transport-manager/information/driver/view-driver/"+this.userData.vendorID;
    this.breadcrumbData['Drivers'] = "organization/transport-manager/information/driver/view-driver/" + this.userData.vendorID;
    this.breadcrumbData['Create Event Driver'] = "";
   }

  ngOnInit(): void {
    if (this.userType != 'transport_manager') {
      this.router.navigate(['/organization/transport-manager/login']);
    }
    this.filteredOptions = this.myControl.valueChanges
    .pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value.name),
      map(name => name ? this._filter(name) : this.options.slice())
    );
    this.addFormLoad();
    this.getBranchList();
    this.getListShift();
    this.minDate = new Date()
  }
    //shift
    getListShift() {
      const obj = {
        orgID: this.storage.get('userInfo').orgID
      };
      this.api.ListShift(obj).then((res: any) => {
        if (res.status == 'success') {
          this.shiftInformation = res.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
    //branch
    getBranchList() {
      const obj = {
        orgID: this.storage.get('userInfo').orgID
      };
      this.api.transportManagerBranchList(obj).then((res: any) => {
        if (res.status == 'success') {
          this.branchInformation = res.data;
          this.branchlists = res.data.map(item => {
            return {
              "name": item.branchName, value: item.branchID,
            }
          });
          if(this.branchlists.length > 0 ){
            this.eventDriverForm.controls.branch.setValue(this.branchlists[0].value)
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    }

  addFormLoad(){
    this.eventDriverForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      branch: new FormControl('',[Validators.required]),
      mobile: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
    });

  }
  public checkError = (controlName: string, errorName: string) => {
    return this.eventDriverForm.controls[controlName].hasError(errorName);
  }
  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }
  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }
  displayFn(user: User): string {
    this.stateData = [];
    this.stateData.push(user);
    return user && user.name ? user.name : '';
  }
  getBranchResult(selected){
    this.getShiftFieldData(selected.value);

  }
  getShiftFieldData(values){
    this.shiftlists = [];
    if(!Array.isArray(values)) values = [values];
    this.shiftInformation.map((item)=>{
      let obj = { 
        name: item.shiftName, /* +' '+ this.getBranchName(item.branch), */
        value:item.shiftID };
      if(item.branch && values.includes(item.branch)) this.shiftlists.push(obj);
    })
  }

  getName(id,data,key,returnValue){
    let result = '';
    if(!Array.isArray(data)) data = [data];
    data.filter((item)=>{
      if(item[key]==id){
        result = item[returnValue];
      }
    });
    return result;
  }
  onSubmit() {
    this.finalCheck=true;
    if(!this.eventDriverForm.valid) return;

    const obj = {
      orgID: this.userData.orgID,
      vendorID: this.userData.vendorID,
    };

    let keys = Object.keys(this.eventDriverForm.value);
    if(keys.length>0){
      for(let k=0;k<keys.length;k++){
        let key = keys[k];
        if(this.eventDriverForm.value[key]!='' && 
        this.eventDriverForm.value[key]!=[] && 
        this.eventDriverForm.value[key]!={}){
          obj[key] = this.eventDriverForm.value[key];
        }
      }
    }
    if(obj['mobile']) obj['mobile'] = parseInt(obj['mobile']);
    this.api.transportManagerDriverCreate(obj).then((res: any) => {
      if (res.status == 'Success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate([this.routerLinks]);
      } if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
      
    }).catch((err) => {
        console.log(err);
    });   
    
  } 
}
